export default {
  sections: {
    business_info: 'Dane firmy',
    bank_info: 'Dane bankowe',
  },
  form: {
    company_name: {
      label: 'Nazwa restauracji',
      placeholder: 'Nazwa restauracji',
    },
    business_name: {
      label: 'Nazwa firmy',
      placeholder: 'Nazwa firmy',
    },
    owner_full_name: {
      label: 'Imię właściciela',
      placeholder: 'Imię właściciela',
    },
    business_address: {
      label: 'Adres firmy',
      placeholder: 'Adres firmy',
    },
    business_zip_code: {
      label: 'Kod pocztowy firmy',
      placeholder: 'Kod pocztowy firmy',
    },
    business_city: {
      label: 'Miasto firmy',
      placeholder: 'Miasto firmy',
    },
    business_country: {
      label: 'Kraj firmy',
      options: {
        DE: 'Niemcy',
        GB: 'Wielka Brytania',
        US: 'Stany Zjednoczone',
      },
    },
    company_phone_number: {
      label: 'Numer telefonu restauracji',
      placeholder: 'Numer telefonu restauracji',
    },
    contact_person_full_name: {
      label: 'Imię i nazwisko osoby kontaktowej',
      placeholder: 'Imię i nazwisko osoby kontaktowej',
    },
    contact_person_phone_number: {
      label: 'Numer telefonu osoby kontaktowej',
      placeholder: 'Numer telefonu osoby kontaktowej',
    },
    contact_person_email: {
      label: 'E-mail osoby kontaktowej',
      placeholder: 'E-mail osoby kontaktowej',
    },
    business_bank_account_holder_name: {
      label: 'Właściciel konta bankowego',
      placeholder: 'Właściciel konta bankowego',
    },
    business_bank_account_number: {
      label: 'Numer konta bankowego',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Numer rozliczeniowy banku',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'NIP firmy',
      placeholder: 'NIP firmy',
    },
  },
};
